import { render, staticRenderFns } from "./DestinationMustSeeTab.vue?vue&type=template&id=15bcdc2e&"
import script from "./DestinationMustSeeTab.vue?vue&type=script&lang=js&"
export * from "./DestinationMustSeeTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports